import { useEffect, useState } from "react";
import { api, fmtEUR } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Truck } from "lucide-react";
import { toast } from "sonner";

// Button „Versand hinzufügen“ mit den aktiven Versandarten.
export const AddShippingButton = ({ order, locked, onUpdated }) => {
  const [items, setItems] = useState([]);
  const load = async (open = true) => {
    if (!open) return;
    try { const r = await api.get("/versandarten"); setItems(r.data.filter((v) => v.aktiv)); }
    catch { toast.error("Versandarten konnten nicht geladen werden."); }
  };
  useEffect(() => { if (!locked) load(); }, [locked]); // eslint-disable-line react-hooks/exhaustive-deps
  const add = async (va) => {
    const has = order.positionen.some((p) => p.typ === "versand");
    if (has && !window.confirm("Versandposition ersetzen?")) return;
    try {
      const r = await api.post(`/auftraege/${order.id}/versandposition`, { versandart_id: va.id, replace: has });
      onUpdated(r.data);
      toast.success(`${va.name} hinzugefügt.`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Versandposition konnte nicht hinzugefügt werden."); }
  };
  if (locked) {
    return (
      <span title="Nach der Preisfreigabe gesperrt – Auftrag erst wieder entsperren." data-testid="add-shipping-locked">
        <Button size="sm" variant="outline" disabled><Truck className="w-4 h-4 mr-1" /> Versand hinzufügen</Button>
      </span>
    );
  }
  return (
    <DropdownMenu onOpenChange={load}>
      <DropdownMenuTrigger asChild>
        <Button size="sm" variant="outline" data-testid="add-shipping-button"><Truck className="w-4 h-4 mr-1" /> Versand hinzufügen</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" data-testid="add-shipping-menu">
        {items.length === 0 && <DropdownMenuItem disabled>Keine aktiven Versandarten</DropdownMenuItem>}
        {items.map((v) => (
          <DropdownMenuItem key={v.id} onSelect={() => add(v)} data-testid={`add-shipping-item-${v.id}`}>
            <span className="flex-1">{v.name}</span><span className="ml-4 font-mono text-xs text-slate-500">{fmtEUR(v.brutto)} brutto</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
